import styled from 'styled-components';
import { Title as BaseTitle, Text as BaseText, Section as BaseSection } from '../../utils/theme';

export const Section = styled(BaseSection)`
  position: relative;
  overflow: hidden;
  min-height: 0vw;
  height: 5.5vw;

  @media (max-width: 600px) {
    height: 60vw;
  }
`;

export const Title = styled(BaseTitle)`
  text-align: left;
  line-height: 0vw;
  font-size: 2.75vw;

  @media (max-width: 600px) {
    font-size: 10vw;
    text-align: center;
  }
`;

export const Text = styled(BaseText)` 
  text-align: left;
  line-height: 0vw;
  font-size: 1vw;

  @media (max-width: 600px) {
    font-size: 4vw;
    text-align: center;
  }
`;

export const ResponsiveText = styled(BaseText)`
  text-align: left;
  line-height: 0vw;
  font-size: 1vw;
  &::before {
    content: "Made with <3 by DubHacks 2024";
  }

  @media (max-width: 600px) {
    font-size: 4vw;
    text-align: center;
    
    &::before {
      content: "Made with 🩷 & 💫 by ©DubHacks 2024";
    }
  }
`;

export const LeftFooterContainer = styled.div`
  position: absolute;
  top: 1.5vw;
  left: 2vw;
  width: 30vw;

  @media (max-width: 600px) {
    top: 0vw;
    left: 50%;
    transform: translateX(-50%);
    width: 90vw;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const RightFooterContainer = styled.div`
  position: absolute;
  top: 1.5vw;
  left: 78vw;
  width: 40vw;
  display: flex;
  flex-direction: column;

  @media (max-width: 600px) {
    top: 40vw;
    left: 50%;
    transform: translateX(-50%);
    width: 90vw;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const LogoContainer = styled.div`
  width: 16vw;
  margin-bottom: 1vw;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 600px) {
    width: 60vw;
    justify-content: center;
    gap: 8vw; /* Added spacing between logos */
  }
`;

export const LogoImage = styled.img`
  width: 2vw;

  @media (max-width: 600px) {
    width: 6vw;
  }
`;

export const ScrollUp = styled.img`
  display: none;

  @media (max-width: 600px) {
    display: block;
    position: absolute;
    top: 26vw;
    left: 80vw;
    width: 8vw;
  }
`;
